import { render, staticRenderFns } from "./CrmService.vue?vue&type=template&id=d13d4c3a&scoped=true"
import script from "./CrmService.vue?vue&type=script&lang=js"
export * from "./CrmService.vue?vue&type=script&lang=js"
import style0 from "./CrmService.vue?vue&type=style&index=0&id=d13d4c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d4c3a",
  null
  
)

export default component.exports